import { useEffect, useState } from 'react';

// Two IntersectionObservers over the rendered sections, replacing the imperative
// pass the old page ran after fetching /sections/*.html:
//
//   1. activeId — which section the nav highlights. The asymmetric rootMargin
//      means "the section occupying the middle band of the viewport", not
//      merely "visible".
//   2. .fade-in reveal — staggered 80ms per element within each wrapper, once.
//
// Deliberately no xAPI here: the landing page never emitted statements. The
// tracking in public/js/app.js belongs to an older revision that index.html
// stopped loading — don't reintroduce it from there.
export function useSectionObservers(ready) {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    if (!ready) return undefined;
    const sections = Array.from(document.querySelectorAll('#content section[id]'));
    if (!sections.length) return undefined;

    const navObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { rootMargin: '-40% 0px -55% 0px' }
    );
    sections.forEach((s) => navObserver.observe(s));

    const wrapperObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('.fade-in:not(.visible)').forEach((el, i) => {
            setTimeout(() => el.classList.add('visible'), i * 80);
          });
          wrapperObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('#content .fp-wrapper').forEach((w) => wrapperObserver.observe(w));

    return () => {
      navObserver.disconnect();
      wrapperObserver.disconnect();
    };
  }, [ready]);

  return activeId;
}
